import React from "react";
import { Button } from "react-bootstrap";
const CButton = ({
  name,
  action,
  variant = "success",
  style = "",
  type = "button",
  className = "",
}) => {
  return (
    <Button
      type={type}
      variant={variant}
      className={"me-2" + " " + className}
      onClick={action}
    >
      {name}
    </Button>
  );
};

export default CButton;
